import { push as changeLocation, replace as replaceLocation } from 'connected-react-router';
import qs from 'query-string';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import UrlManager from '@f/components/higher-order/url';
import urlFields from '@f/etc/url-fields';

const defaultParserProps = {
  // we're keeping this for backward compatibility.
  // TODO: change to 'comma' when detailed view is ready
  arrayFormat: 'none',
  parseNumbers: true,
} as const;

export function useUrl(parserProps = defaultParserProps) {
  const [url, setUrl] = useState<UrlManager | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const url = new UrlManager({
      getter: () => {
        return window.location.search;
      },
      setter: (urlString, replace) => {
        if (replace) {
          dispatch(replaceLocation({ search: urlString }));
        } else {
          dispatch(changeLocation({ search: urlString }));
        }
      },
      parser: urlObj => qs.parse(urlObj, parserProps),
      serializer: urlObj => {
        return qs.stringify(urlObj, parserProps);
      },
      mapping: urlFields,
    });
    setUrl(url);
  }, [parserProps]);

  return url;
}
